import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from './useAuth';
import { FAVORITES_CHANGED_EVENT, readGuestFavorites, writeGuestFavorites } from '@/lib/guestFavorites';

const FAVORITES_CHANGED = FAVORITES_CHANGED_EVENT;

export function useFavoritesIds() {
  const { user } = useAuth();
  const [ids, setIds] = useState<Set<string>>(new Set());

  useEffect(() => {
    let alive = true;
    async function load() {
      if (user) {
        const { data } = await supabase.from('favorites').select('event_id').eq('user_id', user.id);
        if (alive) setIds(new Set((data ?? []).map((r: any) => r.event_id)));
      } else {
        if (alive) setIds(new Set(readGuestFavorites()));
      }
    }
    load();
    // Synchronise toutes les instances du hook (fiche détail ↔ Agenda ↔ Carnet)
    // et les autres onglets (storage).
    const onChange = () => load();
    window.addEventListener(FAVORITES_CHANGED, onChange);
    window.addEventListener('storage', onChange);
    return () => {
      alive = false;
      window.removeEventListener(FAVORITES_CHANGED, onChange);
      window.removeEventListener('storage', onChange);
    };
  }, [user?.id]);

  return {
    ids,
    has: (id: string) => ids.has(id),
    toggle: async (id: string) => {
      const has = ids.has(id);
      const next = new Set(ids);
      if (has) next.delete(id); else next.add(id);
      setIds(next);
      if (user) {
        if (has) await supabase.from('favorites').delete().eq('user_id', user.id).eq('event_id', id);
        else await supabase.from('favorites').insert({ user_id: user.id, event_id: id });
      } else {
        writeGuestFavorites(Array.from(next));
      }
      window.dispatchEvent(new CustomEvent(FAVORITES_CHANGED));
      return !has;
    },
  };
}
